var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rounded-12 text-button-medium enabled:hover:shadow-button disabled:bg-black-300 disabled:text-black-700 flex w-full select-none flex-row items-center justify-center outline-none transition-all enabled:active:shadow-none disabled:cursor-not-allowed",class:{
    'h-32': _vm.size === '32',
    'h-44': _vm.size === '44',
    'h-[50px]': _vm.size === '50',
  },attrs:{"type":"button","disabled":_vm.disabled}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }